import {
  ActivityReportingRequirementsViewModel,
  UpdateActivityReportingRequirementsModel
} from '../../../../features/activities/editActivity/editReportingRequirements/types';

export const getReportingRequirementsInitialEditModel = (
  reportingRequirementsModel: ActivityReportingRequirementsViewModel | undefined
) => {
  const toReturn: UpdateActivityReportingRequirementsModel = {
    CompanyReportingRequirements: [],
    TravellerReportingRequirements: []
  };

  if (reportingRequirementsModel) {
    toReturn.CompanyReportingRequirements.push(
      ...reportingRequirementsModel.CompanyReportingRequirements.map((val) => {
        return {
          BookingRequirementId: val.BookingRequirementId,
          ReportingRequirementId: val.ReportingRequirementId,
          Value: val.Value,
          OptionValues: []
        };
      })
    );

    reportingRequirementsModel.TravellerReportingRequirements.forEach((val) => {
      toReturn.TravellerReportingRequirements.push(
        ...val.ReportingRequirements.map((tr) => {
          return {
            BookingRequirementId: tr.BookingRequirementId,
            ReportingRequirementId: tr.ReportingRequirementId,
            Value: tr.Value,
            OptionValues: [],
            TravellerId: tr.TravellerId
          };
        })
      );
    });
  }
  return toReturn;
};
